import { render, staticRenderFns } from "./LucidFeeds.vue?vue&type=template&id=55906d1a&"
import script from "./LucidFeeds.vue?vue&type=script&lang=js&"
export * from "./LucidFeeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports